// Screen 0: Bitcoin Clock - Block Height Display
import React from 'react';

const BitcoinClockWatch = ({ btcPrice, blockHeight, stats }) => {
  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Arial",
      backgroundColor: "#000000", // Pure black background
      color: "#f7931a", // Bitcoin orange
      padding: "2vw"
    }}>
      <div style={{ textAlign: "center" }}>
        {/* Screen Indicator */}
        <div style={{
          fontSize: "1.5vw",
          color: "#666",
          marginBottom: "1vh"
        }}>
          BITCOIN CLOCK
        </div>

        {/* Main Block Height */}
        <div style={{
          fontSize: "12vw",
          fontWeight: "bold",
          marginBottom: "2vh",
          color: "#f7931a",
          fontFamily: "Courier New, monospace",
          textShadow: "0 0 20px rgba(247, 147, 26, 0.5)"
        }}>
          {blockHeight === null ? "LOADING..." : blockHeight.toLocaleString()}
        </div>

        {/* Subtitle */}
        <div style={{
          fontSize: "3vw",
          color: "#f7931a",
          opacity: 0.8,
          marginBottom: "3vh"
        }}>
          BLOCK HEIGHT
        </div>

        {/* Current Price as secondary info */}
        {btcPrice && (
          <div style={{
            fontSize: "4vw",
            color: "#f7931a",
            opacity: 0.6
          }}>
            ${btcPrice.toLocaleString()}
          </div>
        )}
      </div>
    </div>
  );
};

export default BitcoinClockWatch;



// WEBPACK FOOTER //
// ./src/screens/BitcoinClockWatch.js